import { AutomaticEmailStatus } from "@daytrip/legacy-enums";
import { Exclude, Expose, plainToClass } from "class-transformer";
import { IsArray, IsDefined, IsInt, IsString, IsUUID } from "class-validator";

import { GField, GInputType, GInt, GObjectType } from "../graphql";
import { statusGetter } from "../statusGetter";

import { AutomaticEmailBase } from "./AutomaticEmailBase";
import { AutomaticEmailEvent } from "./AutomaticEmailEvent";

// AutomaticEmail and AutomaticEmailEvent extend the same base class that contains event time properties
// and status prototype. I did this way because status prototype rely on those properties, and both AutomaticEmail
// AutomaticEmailEvent has to have status
// In the future we might remove event times from AutomaticEmail completely, since it's having multiple events
// for separate recipients is a pretty usual thing

@GObjectType("AutomaticEmail")
@GInputType("AutomaticEmailInput")
@Exclude()
export class AutomaticEmail<TType extends Number = Number> extends AutomaticEmailBase {
    @GField()
    @IsString()
    @Expose()
    public mailgunId?: string;

    @GField(() => GInt)
    @IsInt()
    @IsDefined()
    @Expose()
    public type: TType;

    @GField()
    @IsUUID("4")
    @Expose()
    public userId?: string;

    @GField()
    @IsString()
    @Expose()
    public to?: string;

    @GField(() => [AutomaticEmailEvent])
    @IsArray()
    @Expose()
    public events: Array<AutomaticEmailEvent> = [];

    public get status(): AutomaticEmailStatus {
        // If AutomaticEmail has multiple events - then it's status might be mixed
        // (when events have different statuses themselves)
        if (this.events && this.events.length > 0) {
            this.events = plainToClass(AutomaticEmailEvent, this.events);

            // This array will contain distinct statuses of events
            const eventsStatuses: Array<AutomaticEmailStatus> = [];

            // eslint-disable-next-line no-restricted-syntax
            for (const event of this.events) {
                if (eventsStatuses.includes(event.status) === false) {
                    eventsStatuses.push(event.status);
                }
            }

            // If there is more than one status - then it's mixed
            // Otherwise use AutomaticEmail prototype
            if (eventsStatuses.length > 1) {
                return AutomaticEmailStatus.Mixed;
            }
        }

        return statusGetter(this, AutomaticEmail, AutomaticEmailStatus);
    }
}
